// Aria — the human Chief of Staff persona visuals
export const ARIA = {
  portrait:
    "https://static.prod-images.emergentagent.com/jobs/dde143c7-020b-4c51-8ff7-a84392a7d540/images/7eefff1ce0fbb5121eaa865366d5e4b1461d6c309698fdd3937e07afdc724685.jpeg",
  hero:
    "https://static.prod-images.emergentagent.com/jobs/dde143c7-020b-4c51-8ff7-a84392a7d540/images/b01881725d0a680c4d5d77ff98ed1ead1359f22885365df77fb7004d24fa8e0d.jpeg",
};
